import React from 'react';
import { Button, Tooltip } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import './CSVDownloadButton.scss';

const CSVDownloadButton = ({ 
  onClick, 
  disabled = false, 
  variant = "outlined", 
  size = "medium",
  tooltip = "Download CSV",
  label = "Download CSV",
  startIcon = <DownloadIcon />,
  className = ""
}) => {
  return (
    <Tooltip title={tooltip} arrow>
      <span>
        <Button
          variant={variant}
          size={size}
          startIcon={startIcon}
          onClick={onClick}
          disabled={disabled}
          className={`csv-download-button ${className}`}
          aria-label={tooltip}
        >
          {label}
        </Button>
      </span>
    </Tooltip>
  );
};

export default CSVDownloadButton;